module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-x-fill-6db6e276.svg";